export default function SectionHead({ title, count, more, className = '' }) {
  return (
    <div className={`flex items-baseline justify-between gap-3 pb-3 ${className}`}>
      <h2
        className="m-0 flex items-center gap-2 text-[12.5px] font-semibold uppercase tracking-[0.05em]"
        style={{ color: 'var(--ink-3)' }}
      >
        {title}
        {count != null && (
          <span
            className="font-mono text-[10.5px] font-medium px-1.5 py-0.5 rounded-full normal-case tracking-normal"
            style={{ background: 'var(--bg-soft)', color: 'var(--ink-3)', border: '1px solid var(--border)' }}
          >
            {count}
          </span>
        )}
      </h2>
      {more && (
        <div className="text-[12.5px]" style={{ color: 'var(--ink-3)' }}>
          {more}
        </div>
      )}
    </div>
  )
}
